import { useEffect, useState } from 'react';

/**
 * Ab hier gibt es keine Teilung mehr, sondern zwei Ebenen.
 *
 * 1024 px und nicht die 768 aus `use-mobile.tsx`: die geteilte Ansicht braucht
 * 300 px Leiste PLUS eine lesbare Detailspalte. Bei 900 px blieben dem Diff
 * rund 580 px, und der Wort-Diff ist genau das, was geprueft wird.
 */
export const NARROW_VIEWPORT_BREAKPOINT = 1024;

/**
 * Ob der Bildschirm zu schmal fuer die geteilte Ansicht ist.
 *
 * Bewusst ueber `window.innerWidth` und `resize` statt ueber `matchMedia`:
 * jsdom implementiert `matchMedia` nicht (siehe denselben Hinweis in
 * `components/ui/pagination-advanced.tsx`), und `use-mobile.tsx` ruft es
 * ungeschuetzt auf — jede Komponente, die den Hook benutzt, waere damit im
 * Test nicht renderbar. Diese Entscheidung ist der Grund, warum die
 * Stapel-Navigation ueberhaupt pruefbar ist.
 *
 * Die Entscheidung MUSS in JavaScript fallen und nicht per CSS-Breakpoint:
 * auf einem schmalen Bildschirm soll die Detailebene einen Rueckweg-Knopf
 * tragen, den es breit gar nicht gibt. Was nur ausgeblendet ist, ist fuer
 * Screenreader und Tastatur weiterhin da.
 */
export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < NARROW_VIEWPORT_BREAKPOINT,
  );

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < NARROW_VIEWPORT_BREAKPOINT);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return isNarrow;
}
